import methods from '@/enums/methods'
import ThothV2 from '../base/thothV2'
import Thoth from '../base/thoth'

class LiquidationService extends ThothV2 {
    thothV1 = new Thoth()

  sendFile({ route, initialDate, finalDate }) {
    return this.fetch({
      url: `/files-conciliation/${route}`,
      method: methods.POST,
      data: {
        initialDate,
        finalDate,
      },
    })
  }

  sendArquivos({ initialDate, finalDate }) {
    return this.sendFile({
      route: 'continental',
      initialDate,
      finalDate,
    })
  }

  sendPolishop({ initialDate, finalDate }) {
    return this.sendFile({
      route: 'polishop',
      initialDate,
      finalDate,
    })
  }

  sendEquals({ initialDate, finalDate }) {
    return this.sendFile({
      route: 'equals',
      initialDate,
      finalDate,
    })
  }

  sendBoaVista({ initialDate, finalDate }) {  
    return this.sendFile({
      route: 'e-extract',
      initialDate,
      finalDate,
    })
  }

getUploadHistory({ initialDate, finalDate }) {
    return this.thothV1.fetch({
      url: '/fileConciliation',
      method: methods.GET,
      params: {   
        initialDate,
        finalDate,
      },
    })
  }
}

export default new LiquidationService()